export enum retailsPropertyDetailMenuEnum {
    overview = 11,
    retailUnitSize,
    propertyTransaction,
    retailRentalUnitSizeWise,
    officeRentalUnitSizeWise
}
